<template>
    <!-- Meta Tags -->
    <Head title="Aviso de privacidad" />

    <section
        class="bg-legal_mobile lg:bg-legal bg-cover bg-fixed bg-center w-full min-h-screenheaderfooter flex justify-center items-center"
        id="main-content"
    >
        <div class="container py-8">
            <div class="w-full lg:w-1/2">
                <h1 class="mb-4 md:mb-8 text-center lg:text-left uppercase">Aviso de privacidad</h1>
                <div class="flex justify-center items-start !text-xs sm:!text-base">
                    <table
                        style="
                            float: left;
                            border-collapse: collapse;
                            border: none;
                            margin-left: 4.8pt;
                            margin-right: 4.8pt;
                        "
                    >
                        <tbody>
                            <tr>
                                <td style="width: 112.8pt; border: solid white 1pt; padding: 0cm 5.4pt 0cm 5.4pt">
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Identidad y domicilio del Responsable</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: 1pt solid white;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >La sociedad responsable del tratamiento del tratamiento de sus datos
                                            ser&aacute; Comercializadora Pepsico M&eacute;xico, S. de R.L. de C.V. (en
                                            adelante, &ldquo;CPM&rdquo;) con domicilio en</span
                                        ><span style="font-size: 15px; color: rgb(255, 255, 255)">&nbsp;</span
                                        ><span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Bosque de Duraznos 67, Col. Bosque de las Lomas, Miguel Hidalgo, 11700,
                                            CDMX.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Categor&iacute;as de datos personales sujetas al tratamiento</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Para cumplir con las finalidades del tratamiento se&ntilde;aladas en el
                                            presente aviso de privacidad, es necesario recabar y dar tratamiento a los
                                            siguientes datos personales:</span
                                        >
                                    </p>
                                    <div
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <ul style="margin-bottom: 0cm; list-style-type: undefined; margin-left: 26px">
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Datos de identificaci&oacute;n.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Datos de contacto,</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Datos e informaci&oacute;n relativos a sus intereses y preferencias
                                                    en relaci&oacute;n con nuestros productos, servicios, concursos y
                                                    promociones.</span
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >&nbsp;</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Tratamiento de datos personales sensibles</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Para efectos del presente Aviso de Privacidad, CPM no dar&aacute;
                                            tratamiento a datos personales de car&aacute;cter sensible.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Finalidades primarias</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >CPM tratar&aacute; sus datos personales para realizar las siguientes
                                            finalidades primarias:</span
                                        >
                                    </p>
                                    <div
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <ul style="margin-bottom: 0cm; list-style-type: undefined; margin-left: 26px">
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para identificarle y permitirle realizar su registro en la
                                                    promoci&oacute;n.&nbsp;</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para comprobar la veracidad de la informaci&oacute;n que nos
                                                    proporciona.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para permitirle participar en las din&aacute;micas a trav&eacute;s
                                                    del sitio web.&nbsp;</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para realizarle la entrega de los productos y/o premios que usted
                                                    obtenga a trav&eacute;s del sitio web.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para conocer sus preferencias de consumo.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para identificar y prevenir posibles conductas il&iacute;citas que
                                                    pudieran significar una violaci&oacute;n de las disposiciones
                                                    legales vigentes o de nuestros T&eacute;rminos y Condiciones.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para atender sus consultas, aclaraciones y/o reclamaciones en
                                                    relaci&oacute;n con los servicios del sitio web.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-size: 11pt"
                                                    >Realizar actividades de an&aacute;lisis de la informaci&oacute;n y
                                                    datos relacionados con su persona mediante la aplicaci&oacute;n de
                                                    diversas t&eacute;cnicas y tecnolog&iacute;as de an&aacute;lisis de
                                                    datos que nos permitir&aacute;n conocer mejor su perfil, aptitudes e
                                                    intereses.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-size: 11pt"
                                                    >Llevar a cabo actividades de perfilamiento de acuerdo con la
                                                    informaci&oacute;n relativa a sus h&aacute;bitos y preferencias de
                                                    consumo as&iacute; como aquella derivada del uso de t&eacute;cnicas
                                                    de an&aacute;lisis de datos.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-size: 11pt"
                                                    >Realizar reportes estad&iacute;sticos y de car&aacute;cter
                                                    interno.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Para dar cumplimiento a nuestras obligaciones y/o requerimientos
                                                    por partes de autoridades competentes en t&eacute;rminos de la
                                                    normatividad aplicable.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Dar cumplimiento a obligaciones previstas en la normatividad
                                                    aplicable.</span
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Finalidades secundarias</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Si usted no se opone, y en caso de que le sea aplicable, CPM tratar&aacute;
                                            sus datos personales para las siguientes finalidades:&nbsp;</span
                                        >
                                    </p>
                                    <ul style="margin-bottom: 0cm; margin-top: 0cm" type="disc">
                                        <li
                                            style="
                                                margin: 0cm;
                                                text-align: justify;
                                                font-size: 16px;
                                                font-family: 'Century Gothic', sans-serif;
                                                color: rgb(255, 255, 255);
                                                border: none;
                                            "
                                        >
                                            <span style="font-size: 15px; font-family: Arial, sans-serif"
                                                >Contactarle para invitarle a participar en encuestas y/o formularios de
                                                datos.</span
                                            >
                                        </li>
                                        <li
                                            style="
                                                margin: 0cm;
                                                text-align: justify;
                                                font-size: 16px;
                                                font-family: 'Century Gothic', sans-serif;
                                                color: rgb(255, 255, 255);
                                                border: none;
                                            "
                                        >
                                            <span style="font-size: 15px; font-family: Arial, sans-serif"
                                                >Mostrarle y/o enviarle publicidad que pueda resultar de su
                                                inter&eacute;s.</span
                                            >
                                        </li>
                                        <li
                                            style="
                                                margin: 0cm;
                                                text-align: justify;
                                                font-size: 16px;
                                                font-family: 'Century Gothic', sans-serif;
                                                color: rgb(255, 255, 255);
                                                border: none;
                                            "
                                        >
                                            <span style="font-size: 15px; font-family: Arial, sans-serif"
                                                >Para fines estad&iacute;sticos de evaluaci&oacute;n de la
                                                empresa.</span
                                            >
                                        </li>
                                    </ul>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                            ><span style="text-decoration: line-through; color: rgb(255, 255, 255)"
                                                ><del cite="mailto:Gregorio%20Barco%20Vega" datetime="2021-07-28T11:52"
                                                    >&nbsp;</del
                                                ></span
                                            ></span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >&nbsp;</span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >En caso de que no desee que sus datos personales sean tratados para alguna
                                            o todas las finalidades adicionales, desde este momento usted nos puede
                                            comunicar lo anterior al correo&nbsp;</span
                                        ><span style="color: rgb(255, 255, 255)">
                                            <a href="mailto:datos.personales@pepsico.com"
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >datos.personales@pepsico.com</span
                                                ></a
                                            ></span
                                        ><span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >&nbsp;</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Transferencias</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >CPM podr&aacute; transferir sus datos personales, tanto a entidades
                                            nacionales como extranjeras, sin requerir de su consentimiento a:</span
                                        >
                                    </p>
                                    <div
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <ul style="margin-bottom: 0cm; list-style-type: undefined; margin-left: 26px">
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Empresas afiliadas, subsidiarias y/o entidades controladoras,
                                                    nacionales o extranjeros, que operan bajo las mismas
                                                    pol&iacute;ticas internas en materia de protecci&oacute;n de datos
                                                    personales para las finalidades informadas en el presente Aviso de
                                                    Privacidad.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Autoridades competentes en los casos previstos por la normatividad
                                                    aplicable.</span
                                                >
                                            </li>
                                            <li
                                                style="
                                                    margin: 0cm 0cm 9pt;
                                                    text-align: justify;
                                                    font-size: 16px;
                                                    font-family: 'Century Gothic', sans-serif;
                                                    color: rgb(255, 255, 255);
                                                    border: none;
                                                "
                                            >
                                                <span style="font-family: Arial, sans-serif; font-size: 15px"
                                                    >Terceros proveedores de servicios, asociados comerciales con los
                                                    que tengamos celebrados acuerdos jur&iacute;dicos para dar
                                                    cumplimiento a las finalidades informadas en este Aviso de
                                                    Privacidad.</span
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >&nbsp;</span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Si usted no se opone,&nbsp;&nbsp;CPM&nbsp;podr&aacute; transferir sus datos
                                            personales a socios comerciales y/o terceros con los que tengamos celebrados
                                            acuerdos jur&iacute;dicos, para que estos puedan contactarle y ofrecerle
                                            bienes y/o servicios que resulten de su inter&eacute;s, o bien, para que
                                            puedan determinar si usted es sujeto a adquirir los bienes y/o servicios que
                                            dichos socios comerciales y/o terceros ofrecen.</span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 0cm;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Si usted no desea que&nbsp;CPM&nbsp;lleve a cabo la transferencia de
                                            referencia, por favor env&iacute;e un correo electr&oacute;nico
                                            a&nbsp;</span
                                        ><span style="color: rgb(255, 255, 255)"
                                            ><a href="mailto:datos.personales@pepsico.com"
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >datos.personales@pepsico.com</span
                                                ></a
                                            ></span
                                        ><span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >&nbsp;Usted podr&aacute; cambiar de opci&oacute;n en cualquier
                                            momento.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                        height: 6.8pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Medios para ejercer Derechos ARCO</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        height: 6.8pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Usted o su representante legal podr&aacute; ejercer cualquiera de los
                                            derechos de acceso, rectificaci&oacute;n, cancelaci&oacute;n u
                                            oposici&oacute;n (en lo sucesivo &ldquo;Derechos ARCO&rdquo;), as&iacute;
                                            como revocar su consentimiento para el tratamiento de sus datos personales
                                            enviando un correo electr&oacute;nico a nuestro Departamento de
                                            Protecci&oacute;n de Datos Personales a la direcci&oacute;n&nbsp;</span
                                        ><span style="color: rgb(255, 255, 255)"
                                            ><a href="mailto:datos.personales@pepsico.com"
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >datos.personales@pepsico.com</span
                                                ></a
                                            ></span
                                        ><span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >&nbsp;donde se le atender&aacute; en tiempo y forma.&nbsp;</span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Para que nuestro Departamento de Protecci&oacute;n de Datos Personales
                                            pueda darle seguimiento a su solicitud, usted o su representante legal
                                            deber&aacute; acreditar correctamente su identidad acompa&ntilde;ando a su
                                            solicitud una copia de alguna de las identificaciones oficiales vigentes que
                                            se se&ntilde;alan en el mismo.</span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >En caso de que la informaci&oacute;n proporcionada sea err&oacute;nea o
                                            insuficiente, o bien, no se acompa&ntilde;en los documentos de
                                            acreditaci&oacute;n correspondientes, nuestro Departamento de
                                            Protecci&oacute;n de Datos Personales, dentro de los cinco (5) d&iacute;as
                                            h&aacute;biles siguientes a la recepci&oacute;n de la solicitud,
                                            podr&aacute; requerirle que aporte los elementos o documentos necesarios
                                            para dar tr&aacute;mite a la misma. Usted contar&aacute; con diez (10)
                                            d&iacute;as h&aacute;biles para atender el requerimiento, contados a partir
                                            del d&iacute;a siguiente en que lo haya recibido. De no dar respuesta en
                                            dicho plazo, se tendr&aacute; por no presentada la solicitud
                                            correspondiente.</span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Nuestro Departamento de Protecci&oacute;n de Datos Personales le
                                            comunicar&aacute; la determinaci&oacute;n adoptada, en un plazo
                                            m&aacute;ximo de veinte (20) d&iacute;as h&aacute;biles contados desde la
                                            fecha en que se recibi&oacute; la solicitud, a efecto de que, si resulta
                                            procedente, haga efectiva la misma dentro de los quince (15) d&iacute;as
                                            h&aacute;biles siguientes a que se comunique la respuesta.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Opciones y medios para limitar el uso o divulgaci&oacute;n de sus
                                                    datos &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp;personales</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Usted podr&aacute; limitar el uso o divulgaci&oacute;n de sus datos
                                            personales enviando su solicitud a nuestro Departamento de Protecci&oacute;n
                                            de Datos Personales a la direcci&oacute;n&nbsp;</span
                                        ><span style="color: rgb(255, 255, 255)"
                                            ><a href="mailto:datos.personales@pepsico.com"
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >datos.personales@pepsico.com</span
                                                ></a
                                            ></span
                                        ><span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >&nbsp;Los requisitos para acreditar su identidad, as&iacute; como el
                                            procedimiento para atender su solicitud se regir&aacute;n por los mismos
                                            criterios se&ntilde;alados en el apartado anterior.</span
                                        >
                                    </p>
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >En caso de que su solicitud resulte procedente, nuestro Departamento de
                                            Protecci&oacute;n de Datos Personales lo registrar&aacute; en el listado de
                                            exclusi&oacute;n propio de CPM.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Cambios al Aviso de Privacidad</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >CPM se reserva el derecho, bajo su exclusiva discreci&oacute;n, de cambiar,
                                            modificar, agregar o eliminar partes del presente Aviso de Privacidad en
                                            cualquier momento. En tal caso, CPM le informar&aacute; de los cambios por
                                            el mismo medio que ha puesto a su disposici&oacute;n este Aviso de
                                            Privacidad.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >&Uacute;ltima actualizaci&oacute;n</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Enero, 2022.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style="
                                        width: 112.8pt;
                                        border: solid white 1pt;
                                        border-top: none;
                                        padding: 0cm 5.4pt 0cm 5.4pt;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: center;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span style="color: rgb(255, 255, 255)"
                                            ><strong
                                                ><span style="font-size: 15px; font-family: 'Arial', sans-serif"
                                                    >Aceptaci&oacute;n</span
                                                ></strong
                                            ></span
                                        >
                                    </p>
                                </td>
                                <td
                                    style="
                                        width: 328.6pt;
                                        border-top: none;
                                        border-left: none;
                                        border-bottom: 1pt solid white;
                                        border-right: 1pt solid white;
                                        padding: 0cm 5.4pt;
                                        vertical-align: top;
                                    "
                                >
                                    <p
                                        style="
                                            margin-top: 0cm;
                                            margin-right: 0cm;
                                            margin-bottom: 9pt;
                                            margin-left: 0cm;
                                            text-align: justify;
                                            font-size: 16px;
                                            font-family: 'Century Gothic', sans-serif;
                                            color: black;
                                            border: none;
                                        "
                                    >
                                        <span
                                            style="
                                                font-size: 15px;
                                                font-family: Arial, sans-serif;
                                                color: rgb(255, 255, 255);
                                            "
                                            >Al realizar su registro en el portal del sitio web y proporcionar sus datos
                                            personales en el formulario respectivo, usted acepta y reconoce que ha
                                            le&iacute;do el presente Aviso de Privacidad y nos autoriza para dar
                                            tratamiento a sus datos personales de conformidad con lo se&ntilde;alado en
                                            este Aviso de Privacidad.</span
                                        >
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p
                        style="
                            margin-top: 0cm;
                            margin-right: 0cm;
                            margin-bottom: 9pt;
                            margin-left: 0cm;
                            text-align: justify;
                            font-size: 16px;
                            font-family: 'Century Gothic', sans-serif;
                            color: black;
                            border: none;
                        "
                    >
                        <span style="font-size: 15px; font-family: Arial, sans-serif; color: rgb(255, 255, 255)"
                            >&nbsp;</span
                        >
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Privacy",
    props: ["errors"],
    data() {
        return {
            form: this.$inertia.form({
                name: null,
                email: null,
                subject: null,
                message: null,
            }),
        };
    },
    methods: {
        handleForm() {
            dataLayer.push({
                event: "form_contacto",
                user_id: this.form.email,
            });
            this.form.post(this.$page.props.baseUrl + "/contacto");
        },
    },
};
</script>
<style></style>
